// Load JSON content packs at boot.

import type { AbilityDef, BossDef, ContentPack, EnemyDef } from './schemas';
import { validateAbilityDef, validateBossDef, validateEnemyDef } from './schemas';

import meritousLegacy from './enemies/meritous-legacy.json';
import forestWisp from './enemies/forest-wisp.json';
import meridianBoss from './bosses/meridian.json';
import psiCircuit from './abilities/psi-circuit.json';
import reflectShield from './abilities/reflect-shield.json';
import dashBlink from './abilities/dash-blink.json';

let pack: ContentPack | null = null;
const enemiesById = new Map<string, EnemyDef>();
const bossesById = new Map<string, BossDef>();
const abilitiesById = new Map<string, AbilityDef>();

export function loadContentPack(): ContentPack {
  if (pack) return pack;

  const enemies = [meritousLegacy, forestWisp].map(validateEnemyDef);
  const bosses = [meridianBoss].map(validateBossDef);
  const abilities = [psiCircuit, reflectShield, dashBlink].map(validateAbilityDef);

  pack = { enemies, bosses, abilities };
  enemiesById.clear();
  bossesById.clear();
  abilitiesById.clear();
  for (const e of enemies) enemiesById.set(e.id, e);
  for (const b of bosses) bossesById.set(b.id, b);
  for (const a of abilities) abilitiesById.set(a.id, a);
  return pack;
}

export function getContentPack(): ContentPack {
  return pack ?? loadContentPack();
}

export function getEnemyDef(id: string): EnemyDef | undefined {
  return enemiesById.get(id);
}

export function getBossDef(id: string): BossDef | undefined {
  return bossesById.get(id);
}

export function getAbilityDef(id: string): AbilityDef | undefined {
  return abilitiesById.get(id);
}

export function getSpawnableEnemies(): EnemyDef[] {
  return getContentPack().enemies.filter((e) => e.id !== 'meritous-legacy' && e.spawn && e.spawn.weight > 0);
}

/** Reset for tests. */
export function resetContentPack(): void {
  pack = null;
  enemiesById.clear();
  bossesById.clear();
  abilitiesById.clear();
}
